import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const CommonCountryFlage = ({ 
  imageFlage = true, 
  disabled = true,
  country
 }) => {
  return (
    <>
      <PhoneInput
        // defaultCountry="it"  // default country set to Italy (you can change this)
        disabled={disabled}
        disableDropdown={disabled}
        country={country ? country.toLowerCase():"it"}  // set country code for the flag to show
        buttonStyle={{
          width: 250, // Set width of the button (which includes the flag)
          padding: 0, // Remove padding if needed to fit the flag better
        }}
        inputStyle={{ display: 'none' }} // Hide the actual input field if necessary
        specialLabel=""
        className={`phone-input-container ${disabled ? 'disabled-input disabled-inputCountryFlage ' : ''}`}
        // Inline styles applied to the selected flag
        style={{
          // Apply styles to the selected flag container
          '.selected-flag': {
            backgroundColor: 'red !important',
          },
        }}
      />
    </>
  );
};

export default CommonCountryFlage;
